import clashLogo from "../assets/images/logo.png";
import lifeLogo from "../assets/images/life-logo.png";

const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

export const applyWatermark = async (file: File, tournamentName?: string): Promise<File> => {
  const imageSrc = URL.createObjectURL(file);
  try {
    const isLife = tournamentName?.toLowerCase().includes("life");

    const logoPromises: Promise<HTMLImageElement>[] = [loadImage(imageSrc), loadImage(clashLogo)];
    if (isLife) logoPromises.push(loadImage(lifeLogo));

    const [image, clash, life] = await Promise.all(logoPromises);

    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext("2d")!;
    ctx.drawImage(image, 0, 0);

    ctx.globalAlpha = 0.5;

    const logoScale = 0.12;
    const padding = image.width * 0.02;

    if (isLife && life) {
      const clashW = image.width * logoScale;
      const clashH = (clash.height / clash.width) * clashW;
      const lifeW = image.width * logoScale;
      const lifeH = (life.height / life.width) * lifeW;

      const gap = image.width * 0.02;
      const totalW = clashW + gap + lifeW;
      const maxH = Math.max(clashH, lifeH);
      const startX = (image.width - totalW) / 2;
      const y = image.height - maxH - padding;

      ctx.drawImage(clash, startX, y + (maxH - clashH) / 2, clashW, clashH);
      ctx.drawImage(life, startX + clashW + gap, y + (maxH - lifeH) / 2, lifeW, lifeH);
    } else {
      const logoWidth = image.width * logoScale;
      const logoHeight = (clash.height / clash.width) * logoWidth;
      const x = (image.width - logoWidth) / 2;
      const y = image.height - logoHeight - padding;
      ctx.drawImage(clash, x, y, logoWidth, logoHeight);
    }

    ctx.globalAlpha = 1.0;

    const blob = await new Promise<Blob>((resolve) =>
      canvas.toBlob((b) => resolve(b!), "image/jpeg", 0.9)
    );

    return new File([blob], file.name, { type: "image/jpeg" });
  } finally {
    URL.revokeObjectURL(imageSrc);
  }
};
